import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllAtmTypes } from "../api/getAllAtmTypes";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useAtmTypesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetAtmType []>([]);
  const getAllAtmTypesQuery = useGetAllAtmTypes({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllAtmTypesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllAtmTypesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllAtmTypesQuery.data ? getAllAtmTypesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Τύπος",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Τύπου");
        break;
      case "edit":
        title = t("Επεξεργασία Τύπου");
        break
        case "delete":
        title = t("Διαγραφή Τύπου");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllAtmTypesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
